const emptyOption = { label: "", value: "" }

export default emptyOption
